import { createAction } from '@reduxjs/toolkit'

import { IResponseError } from '@lib/error'
import { IPitchSubmissionComparison } from '../types'

export const fetchPitchComparison = createAction(
  'submissions/fetchPitchComparison',
  (submissionId: number) => ({
    payload: {
      submissionId,
    },
  }),
)
export const fetchPitchComparisonSuccess = createAction(
  'submissions/fetchPitchComparisonSuccess',
  (submissionId: number, comparison: IPitchSubmissionComparison) => ({
    payload: {
      submissionId,
      comparison,
    },
  }),
)
export const fetchPitchComparisonError = createAction(
  'submissions/fetchPitchComparisonError',
  (submissionId: number, error: IResponseError) => ({
    payload: {
      submissionId,
      error,
    },
  }),
)
